import React from "react";
import "./Pathway.css";

const Pathway = ({ slot }) => {
  const { label, gridColumn, gridRow } = slot;

  const colSpan = parseSpan(gridColumn);
  const rowSpan = parseSpan(gridRow);
  const isVertical = rowSpan > colSpan;

  return (
    <div
      className={`pathway ${isVertical ? "pathway--vertical" : "pathway--horizontal"}`}
      style={{ gridColumn, gridRow }}
      aria-label={`Walkway: ${label}`}
    >
      {/* Centre dashed line */}
      <div className="pathway__dash" />

      {/* Street name pill */}
      <div className="pathway__label-wrap">
        <svg className="pathway__icon" viewBox="0 0 14 14" fill="none">
          <rect x="1" y="4" width="12" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.4"/>
          <path d="M4 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" stroke="currentColor" strokeWidth="1.4"/>
          <path d="M4 10v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1" stroke="currentColor" strokeWidth="1.4"/>
        </svg>
        <span className="pathway__label">{label}</span>
      </div>
    </div>
  );
};

function parseSpan(cssValue = "") {
  const spanMatch = cssValue.match(/span\s+(\d+)/i);
  if (spanMatch) return parseInt(spanMatch[1], 10);
  const parts = cssValue.split("/").map(s => parseInt(s.trim(), 10));
  if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1]))
    return Math.abs(parts[1] - parts[0]);
  return 1;
}

export default Pathway;